import { FC } from 'react';
import { ExtraFeeField, ExtraFeeContainer } from './index.view';
import { currencyFormat } from 'utils/number';
import { useTranslation } from 'react-i18next';

interface ExtraFeeProps {
  extraFee: { name: string; price: number }[];
  includedTax?: { taxPrice: number }[];
}

const ExtraFee: FC<ExtraFeeProps> = ({ extraFee, includedTax }) => {
  const { t } = useTranslation();

  const extraFeeList = extraFee?.map((item) => {
    const { name, price } = item;
    return (
      <ExtraFeeContainer>
        <ExtraFeeField>{name}</ExtraFeeField>
        <ExtraFeeField>{`+${currencyFormat(price)}`}</ExtraFeeField>
      </ExtraFeeContainer>
    );
  });

  const renderIncludedTax = () => {
    const taxPrice = includedTax?.reduce((sum, current) => {
      return sum + current.taxPrice;
    }, 0);

    return includedTax && includedTax[0]?.taxPrice !== null ? (
      <ExtraFeeContainer>
        <ExtraFeeField>{t('billIncludedTax')}</ExtraFeeField>
        <ExtraFeeField>{`${currencyFormat(taxPrice)}`}</ExtraFeeField>
      </ExtraFeeContainer>
    ) : null;
  };

  return (
    <>
      {renderIncludedTax()}
      {extraFee?.length > 0 ? extraFeeList : null}
    </>
  );
};

export default ExtraFee;
